import { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import '../App.css';
import depositTabImg from '../assets/images/depositTab.svg'
import withdrwaTabImg from '../assets/images/withdrwaTab.svg'
import zapIMg from '../assets/images/zap.png';
import { Toast } from 'primereact/toast';
import Decimal from 'decimal.js';
import { useAccount, useNetwork } from 'wagmi';
import ConnectBtn from './ConnectBtn';
import { ProgressBar } from 'primereact/progressbar';
import ClaimBtn from './ClaimBtn';
// import Stake from './StakeBtn';
import usdt from '../assets/images/usdt2.png'
import eth from '../assets/images/eth.png'

interface ManageBtnProps {
  vaultName: string;
  Img1: string;
  Img2: string;
  addressNew: string;
  symbol: string
}

function ManageBtn({ vaultName, Img1, Img2, addressNew, symbol }: ManageBtnProps) {



  const masterChefABI = [{ "type": "constructor", "inputs": [{ "name": "_SLUSH", "type": "address", "internalType": "contract IERC20" }, { "name": "_EXTRA", "type": "address", "internalType": "contract IERC20" }], "stateMutability": "nonpayable" }, { "type": "function", "name": "ACC_REWARDS_PRECISION", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "BOOST_PRECISION", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "EXTRA", "inputs": [], "outputs": [{ "name": "", "type": "address", "internalType": "contract IERC20" }], "stateMutability": "view" }, { "type": "function", "name": "MAX_BOOST_PRECISION", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "REWARDS_RATE_TOTAL_PRECISION", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "SLUSH", "inputs": [], "outputs": [{ "name": "", "type": "address", "internalType": "contract IERC20" }], "stateMutability": "view" }, { "type": "function", "name": "add", "inputs": [{ "name": "_allocPoint", "type": "uint256", "internalType": "uint256" }, { "name": "_lpToken", "type": "address", "internalType": "contract IERC20" }, { "name": "_isRegular", "type": "bool", "internalType": "bool" }, { "name": "_withUpdate", "type": "bool", "internalType": "bool" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "boostContract", "inputs": [], "outputs": [{ "name": "", "type": "address", "internalType": "address" }], "stateMutability": "view" }, { "type": "function", "name": "deposit", "inputs": [{ "name": "_pid", "type": "uint256", "internalType": "uint256" }, { "name": "_amount", "type": "uint256", "internalType": "uint256" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "emergencyWithdraw", "inputs": [{ "name": "_pid", "type": "uint256", "internalType": "uint256" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "extraPerBlock", "inputs": [{ "name": "_isRegular", "type": "bool", "internalType": "bool" }], "outputs": [{ "name": "amount", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "getBoostMultiplier", "inputs": [{ "name": "_user", "type": "address", "internalType": "address" }, { "name": "_pid", "type": "uint256", "internalType": "uint256" }], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "lpToken", "inputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "outputs": [{ "name": "", "type": "address", "internalType": "contract IERC20" }], "stateMutability": "view" }, { "type": "function", "name": "massUpdatePools", "inputs": [], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "owner", "inputs": [], "outputs": [{ "name": "", "type": "address", "internalType": "address" }], "stateMutability": "view" }, { "type": "function", "name": "pendingExtra", "inputs": [{ "name": "_pid", "type": "uint256", "internalType": "uint256" }, { "name": "_user", "type": "address", "internalType": "address" }], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "pendingSlushs", "inputs": [{ "name": "_pid", "type": "uint256", "internalType": "uint256" }, { "name": "_user", "type": "address", "internalType": "address" }], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "poolInfo", "inputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "outputs": [{ "name": "accSlushPerShare", "type": "uint256", "internalType": "uint256" }, { "name": "accExtraPerShare", "type": "uint256", "internalType": "uint256" }, { "name": "lastRewardBlock", "type": "uint256", "internalType": "uint256" }, { "name": "allocPoint", "type": "uint256", "internalType": "uint256" }, { "name": "totalBoostedShare", "type": "uint256", "internalType": "uint256" }, { "name": "isRegular", "type": "bool", "internalType": "bool" }], "stateMutability": "view" }, { "type": "function", "name": "poolLength", "inputs": [], "outputs": [{ "name": "pools", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "regularFarmsRate", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "renounceOwnership", "inputs": [], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "set", "inputs": [{ "name": "_pid", "type": "uint256", "internalType": "uint256" }, { "name": "_allocPoint", "type": "uint256", "internalType": "uint256" }, { "name": "_withUpdate", "type": "bool", "internalType": "bool" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "slushPerBlock", "inputs": [{ "name": "_isRegular", "type": "bool", "internalType": "bool" }], "outputs": [{ "name": "amount", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "specialFarmsRate", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "totalExtraPerBlock", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "totalRegularAllocPoint", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "totalSlushsPerBlock", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "totalSpecialAllocPoint", "inputs": [], "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "transferOwnership", "inputs": [{ "name": "newOwner", "type": "address", "internalType": "address" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "updateBoostContract", "inputs": [{ "name": "_newBoostContract", "type": "address", "internalType": "address" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "updateBoostMultiplier", "inputs": [{ "name": "_user", "type": "address", "internalType": "address" }, { "name": "_pid", "type": "uint256", "internalType": "uint256" }, { "name": "_newMultiplier", "type": "uint256", "internalType": "uint256" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "updatePool", "inputs": [{ "name": "_pid", "type": "uint256", "internalType": "uint256" }], "outputs": [{ "name": "pool", "type": "tuple", "internalType": "struct MasterchefRiveraV2.PoolInfo", "components": [{ "name": "accSlushPerShare", "type": "uint256", "internalType": "uint256" }, { "name": "accExtraPerShare", "type": "uint256", "internalType": "uint256" }, { "name": "lastRewardBlock", "type": "uint256", "internalType": "uint256" }, { "name": "allocPoint", "type": "uint256", "internalType": "uint256" }, { "name": "totalBoostedShare", "type": "uint256", "internalType": "uint256" }, { "name": "isRegular", "type": "bool", "internalType": "bool" }] }], "stateMutability": "nonpayable" }, { "type": "function", "name": "updateRates", "inputs": [{ "name": "_regularFarmsRate", "type": "uint256", "internalType": "uint256" }, { "name": "_specialFarmsRate", "type": "uint256", "internalType": "uint256" }, { "name": "_withUpdate", "type": "bool", "internalType": "bool" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "updateTotalExtraPerBlock", "inputs": [{ "name": "_totalExtraPerBlock", "type": "uint256", "internalType": "uint256" }, { "name": "_withUpdate", "type": "bool", "internalType": "bool" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "updateTotalSlushsPerBlock", "inputs": [{ "name": "_totalSlushsPerBlock", "type": "uint256", "internalType": "uint256" }, { "name": "_withUpdate", "type": "bool", "internalType": "bool" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "updateWhiteList", "inputs": [{ "name": "_user", "type": "address", "internalType": "address" }, { "name": "_isValid", "type": "bool", "internalType": "bool" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "function", "name": "userInfo", "inputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }, { "name": "", "type": "address", "internalType": "address" }], "outputs": [{ "name": "amount", "type": "uint256", "internalType": "uint256" }, { "name": "rewardDebt", "type": "uint256", "internalType": "uint256" }, { "name": "extraRewardDebt", "type": "uint256", "internalType": "uint256" }, { "name": "boostMultiplier", "type": "uint256", "internalType": "uint256" }], "stateMutability": "view" }, { "type": "function", "name": "whiteList", "inputs": [{ "name": "", "type": "address", "internalType": "address" }], "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }], "stateMutability": "view" }, { "type": "function", "name": "withdraw", "inputs": [{ "name": "_pid", "type": "uint256", "internalType": "uint256" }, { "name": "_amount", "type": "uint256", "internalType": "uint256" }], "outputs": [], "stateMutability": "nonpayable" }, { "type": "event", "name": "AddPool", "inputs": [{ "name": "pid", "type": "uint256", "indexed": true, "internalType": "uint256" }, { "name": "allocPoint", "type": "uint256", "indexed": false, "internalType": "uint256" }, { "name": "lpToken", "type": "address", "indexed": true, "internalType": "contract IERC20" }, { "name": "isRegular", "type": "bool", "indexed": false, "internalType": "bool" }], "anonymous": false }, { "type": "event", "name": "Deposit", "inputs": [{ "name": "user", "type": "address", "indexed": true, "internalType": "address" }, { "name": "pid", "type": "uint256", "indexed": true, "internalType": "uint256" }, { "name": "amount", "type": "uint256", "indexed": false, "internalType": "uint256" }], "anonymous": false }, { "type": "event", "name": "EmergencyWithdraw", "inputs": [{ "name": "user", "type": "address", "indexed": true, "internalType": "address" }, { "name": "pid", "type": "uint256", "indexed": true, "internalType": "uint256" }, { "name": "amount", "type": "uint256", "indexed": false, "internalType": "uint256" }], "anonymous": false }, { "type": "event", "name": "OwnershipTransferred", "inputs": [{ "name": "previousOwner", "type": "address", "indexed": true, "internalType": "address" }, { "name": "newOwner", "type": "address", "indexed": true, "internalType": "address" }], "anonymous": false }, { "type": "event", "name": "SetPool", "inputs": [{ "name": "pid", "type": "uint256", "indexed": true, "internalType": "uint256" }, { "name": "allocPoint", "type": "uint256", "indexed": false, "internalType": "uint256" }], "anonymous": false }, { "type": "event", "name": "UpdateBoostContract", "inputs": [{ "name": "boostContract", "type": "address", "indexed": true, "internalType": "address" }], "anonymous": false }, { "type": "event", "name": "UpdateBoostMultiplier", "inputs": [{ "name": "user", "type": "address", "indexed": true, "internalType": "address" }, { "name": "pid", "type": "uint256", "indexed": false, "internalType": "uint256" }, { "name": "oldMultiplier", "type": "uint256", "indexed": false, "internalType": "uint256" }, { "name": "newMultiplier", "type": "uint256", "indexed": false, "internalType": "uint256" }], "anonymous": false }, { "type": "event", "name": "UpdatePool", "inputs": [{ "name": "pid", "type": "uint256", "indexed": true, "internalType": "uint256" }, { "name": "lastRewardBlock", "type": "uint256", "indexed": false, "internalType": "uint256" }, { "name": "lpSupply", "type": "uint256", "indexed": false, "internalType": "uint256" }, { "name": "accSlushPerShare", "type": "uint256", "indexed": false, "internalType": "uint256" }, { "name": "accExtraPerShare", "type": "uint256", "indexed": false, "internalType": "uint256" }], "anonymous": false }, { "type": "event", "name": "UpdateRates", "inputs": [{ "name": "regularFarmRate", "type": "uint256", "indexed": false, "internalType": "uint256" }, { "name": "specialFarmRate", "type": "uint256", "indexed": false, "internalType": "uint256" }], "anonymous": false }, { "type": "event", "name": "UpdateWhiteList", "inputs": [{ "name": "user", "type": "address", "indexed": true, "internalType": "address" }, { "name": "isValid", "type": "bool", "indexed": false, "internalType": "bool" }], "anonymous": false }, { "type": "event", "name": "Withdraw", "inputs": [{ "name": "user", "type": "address", "indexed": true, "internalType": "address" }, { "name": "pid", "type": "uint256", "indexed": true, "internalType": "uint256" }, { "name": "amount", "type": "uint256", "indexed": false, "internalType": "uint256" }], "anonymous": false }]

  const { chain } = useNetwork();
  const [visible, setVisible] = useState(false);
  const [maxLimit, setMaxLimit] = useState<any>(null);
  const [depositAmout, setdepositAmout] = useState<any>("0");
  const [isApproved, setisApproved] = useState(false);
  const [walletBalance, setWalletBalance] = useState<any>(null);
  const [withdrawAmout, setwithdrawAmout] = useState("0");
  const [userShare, setUserShare] = useState("0");
  const { address, isConnected } = useAccount();

  const [deatils, setDeatils] = useState({
    "vaultName": "",
    "symbol": "",
    "assetName": "",
    "assetImg": "",
    "assetImg2": "",
    "asset1": "",
    "asset2": "",
    "tvl": "",
    "tvlInusd": "",
    "holding": "",
    "networkImg": "",
    "fundManger": "",
    "vaultReturn": "",
    "vaultOwner": "",
    "rpc": "",
    "vaultAddress": "",
    "denominationDecimal": 0,
    "explorerLink": "",
    "poweredBy": "",
    "chainId": "",
    "chainName": "",
    "lpApr": 0,
    "totalSupply": 0,
    "xirvApr": 0,
    "totalApr": 0,
    "feeTier": Number,
    "partnerFee": 0,
    "feeDecimals": 0,
    "withdrawFee": 0,
    "fundManagerFee": 0,
    "protocolFee": 0,
    "withdrawFeeDecimals": 0,
    "buyToken": "",
    "detailsNew": "",
    "website": "",
    "dex": [],
    "tags": [],
    "apr": [],
    "strategyType": [],
    "description": "",
    "stTypes": "",
    "tickLower": 0,
    "tickUpper": 0

  });

  const handledepositAmoutChange = (event: any) => {
    let val = event.target.value;
    if (val === "") {
      val = "0";
    }
    const enteredVal = new Decimal(val);
    const mxlmtVal = new Decimal(maxLimit);
    if (enteredVal.gt(mxlmtVal)) {
      setisApproved(false);
    } else {
      setisApproved(true);
    }
    setdepositAmout(event.target.value);
  };

  const [isTransactionOnGoing, setIsTransactionOnGoing] = useState(false);

  const showDialog = () => {
    setVisible(true);
  };

  const hideDialog = () => {
    setVisible(false);
  };

  const getTwoDecimal = (num: any) => {
    const roundedNum = Math.floor(num * 100) / 100;
    return roundedNum;
  }
  const fnum = (x: any) => {
    if (isNaN(x)) return x;

    if (x < 999) {
      return getTwoDecimal(x);
    }

    if (x < 1000) {
      return getTwoDecimal(x);
    }

    if (x < 10000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 100000) {
      return getTwoDecimal(x / 1000) + "K";
    }

    if (x < 1000000) {
      return getTwoDecimal(x / 1000) + "K";
    }
    if (x < 10000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000) {
      return getTwoDecimal(x / 1000000) + "M";
    }

    if (x < 1000000000000) {
      return getTwoDecimal(x / 1000000000) + "B";
    }

    return "1T+";
  }


  interface CustomTabHeaderProps {
    icon: string;
    title: string;
  }

  const CustomTabHeader: React.FC<CustomTabHeaderProps> = ({ icon, title }) => {
    return (
      <>
        {icon && <img src={icon} alt="Icon" style={{ marginRight: '10px', width: '28px' }} />}
        <span>{title}</span>
      </>
    );
  };
  const updateDepositMax = () => {
    setdepositAmout(walletBalance);
    const walletBalanceVal = new Decimal(walletBalance);
    const maxLimitVal = new Decimal(maxLimit);
    if (walletBalanceVal.gt(maxLimitVal)) {
      setisApproved(false);
    } else {
      setisApproved(true);
    }
  }


  const handlewithdrawAmoutChange = (event: any) => {
    setwithdrawAmout(event.target.value);
  };
  const updateWithdrawMax = () => {
    setwithdrawAmout(userShare);
  }


  return (
    <>
      <button className='mt-05 btn-riv-manage whitespace-nowrap' type="button" onClick={showDialog}>
        Manage
      </button>
      <Dialog visible={visible} className="custom-dialog" onHide={hideDialog} modal header={`Manage ${vaultName}`}>
        <div className='second_section outer_section_detail pos_sticky '>
          <TabView >
            <TabPanel header={<CustomTabHeader icon={depositTabImg} title="Stake" />}>
              <div className='mt-3'>
                <div className='dsp mb-3'>
                  <div className='fnt_wgt_800'>Amount</div>
                  <button className='btn mxBtn my-div' onClick={updateDepositMax}>Max</button>
                </div>
                <div className='dsp backGrd mb-3 border2'>
                  <div>
                    <input
                      className='input_box_details'
                      type="number"
                      id="first_name"
                      name="first_name"
                      value={depositAmout}
                      onChange={handledepositAmoutChange}
                    />
                  </div>
                  <div className='header_font_size2 redHatFont'><span><img src={Img1} alt='btc img' className='btc_asst_img_width' /></span><span><img src={Img2} alt='btc img' className='btc_img_width2' /></span>{vaultName}</div>
                </div>
                <div className='dsp'>
                  <div></div>
                  <div className='buy_cake'> <a rel="noreferrer" target='_blank' href={deatils?.buyToken} className='clr_prpl'>{symbol}{deatils?.assetName}</a></div>
                </div>
                <div>
                  <div className='flexFoot'>
                    <button className='btn mt-05 btn-riv-primary whitespace-nowrap' type="button">
                      Stake
                    </button>
                    <button className='btn mt-05 btn-riv-primary-cancel whitespace-nowrap' type="button" onClick={hideDialog}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel header={<CustomTabHeader icon={withdrwaTabImg} title="Unstake" />}>
              <div className='mt-3 '>
                <div>
                </div>
                <div className='dsp mb-3'>
                  <div className='fnt_wgt_800'>Amount</div>
                  <button className='btn mxBtn my-div' onClick={updateDepositMax}>Max</button>
                </div>
                <div className='dsp backGrd mb-3 '>
                  <div><input
                    className='input_box_details '
                    type="number"
                    id="first_name_2"
                    name="first_name_2"
                    value={withdrawAmout}
                    onChange={handlewithdrawAmoutChange}
                  />
                  </div>
                  <div className='margStake header_font_size2 redHatFont'><span><img src={Img1} alt='btc img' className='btc_asst_img_width' /></span><span><img src={Img2} alt='btc img' className='btc_img_width2' /></span>{vaultName}</div>
                </div>
                <div className='dsp'>
                  <div></div>
                  <div className='buy_cake'> <a rel="noreferrer" target='_blank' href={deatils?.buyToken} className='clr_prpl'></a></div>
                </div>
                <div className='flexFoot'>
                  <button className='btn mt-05 btn-riv-primary whitespace-nowrap' type="button">
                    Stake
                  </button>
                  <button className='btn mt-05 btn-riv-primary-cancel whitespace-nowrap' type="button" onClick={hideDialog}>
                    Cancel
                  </button>
                </div>

              </div>
            </TabPanel>
          </TabView>
        </div>
      </Dialog >
    </>
  );
}

export default ManageBtn;


